<template>
  <div class="basic_con">
    <Frame title="客户授信">
      <template slot="contentSlot">
        <div>
          <div id="customer_credit_chart"></div>
          <div class="quota_wrapper">
            <div class="quota">
              <div class="quota_label">授信额度：</div>
              <div class="quota_val">{{checkedCreditAll}}</div>
            </div>
          </div>
        </div>
      </template>
    </Frame>
  </div>
</template>

<script>
import Frame from "../../frame.vue";
import * as echarts from "echarts";
import "echarts-liquidfill";
import "@/util/echarts-auto-tooltip";
import { getUsedAmountByCustId } from "@/api/factoring/factoringCustomer";
import { floatAdd ,floatSub} from "@/util/util";
export default {
  name: "customerCredit",
  components: {
    Frame,
  },
  data() {
    return {
      chart: null,
      tootipTimer: null,
      checkedCreditAll:0,
      dataList: [
        // { value: 57, name: "已用" },
        // { value: 42, name: "可用" },
      ],
    };
  },
  mounted() {
    this.initChart();
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.tootipTimer.clearLoop();
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = echarts.init(
        document.getElementById("customer_credit_chart")
      );

      window.onresize = () => {
        this.chart.resize();
      };
      this.$nextTick(() => {
        this.getDetail();
      });
    },
    async getDetail() {
      let res = await getUsedAmountByCustId({ custId: this.$route.params.id });
      if (res.data.code == 200) {
        let usedAmount = 0;
        let usableAmount = 0;
        let checkedCreditAll = 0;
        res.data.data.map((item) => {
          usedAmount =floatAdd(usedAmount,Number(item.usedAmount)) ;
          usableAmount =floatAdd(usableAmount,(floatSub(Number(item.checkedCredit),Number(item.usedAmount)))) 
          checkedCreditAll=floatAdd(checkedCreditAll,Number(item.checkedCredit)) 
        });
        this.checkedCreditAll=this.getMoney(checkedCreditAll);
        (this.dataList = [
          { value: usedAmount, name: "已用" },
          { value: usableAmount, name: "可用" },
        ]),
          this.setOptions();
      } else {
        this.$message.error(res.data.message);
      }
    },

    setOptions() {
      let option = {
        color: ["#8ACFAA", "#5CACFF"],

        tooltip: {
          trigger: "item",
          show: true,
        },
        legend: {
          show: true,
          orient: "horizontal",
          x: "center",
          y: "70%",
          icon: "circle",
          itemWidth: 8,
          itemHeight: 8,
          itemGap: 30,
          align: "auto",
        },
        series: [
          {
            type: "pie",
            radius: "40%",
            center: ["50%", "30%"],
            data: this.dataList,
            label: {
              show: true,
              normal: {
                show: true,
                formatter: ["{b|{b}:}{c|{c}}"].join("\n"),
                position: "outside",
                rich: {
                  b: {
                    fontSize: 12,
                    padding: [0, 0, 0, 2],
                  },
                  c: {
                    fontSize: 12,
                    padding: [2, 0, 0, 10],
                    align: "left",
                  },
                },
              },
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };

      this.tootipTimer =
        // = autoHover(this.chart, option, 3, 3000);
        tools.loopShowTooltip(this.chart, option, {
          loopSeries: true,
        });
      this.chart.setOption(option);
    },
    // btnClick() {
    //   this.$emit("fatherEvent", "foodNews");
    // },
  },
};
</script>
<style scoped lang="scss">
$base_width: 1920;
$base_height: 1080;
@function vw($px) {
  @return ($px / $base_width) * 100vw;
}
@function vh($px) {
  @return ($px / $base_height) * 100vh;
}
.basic_con {
  width: 100%;
  margin-top: 20px;
  background-color: #fff;
  border-radius: 10px;
  height: 397px;
  position: relative;
}
#customer_credit_chart {
  width: 100%;
  height: 270px;
}
.quota_wrapper {
  margin: 0 auto;
  text-align: center;
  left: 0;
  display: flex;
  justify-content: center;
  right: 0;
  align-items: center;
  .quota {
    display: flex;
    padding: 2px 5px;
    align-items: center;
    background-color: rgba(64, 158, 255, 1);
    border: none;
    border-radius: 5px;
    box-shadow: 0px 0px 5px rgba(64, 158, 255, 49%);
    font-family: "微软雅黑", sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 18px;
    color: #ffffff;
    text-align: center;
    .quota_val {
      // padding-left: 10px;
    }
  }
}
</style>

